function scrollToDiv() {
    const element = document.getElementById('target-section'); // Make sure your section has this ID
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
}

window.onscroll = function() {
    const marqueeContainer = document.querySelector('.marquee-container');
    const fullWidthBar = document.querySelector('.full-width-bar');

    if (marqueeContainer && fullWidthBar) {
        const rect = marqueeContainer.getBoundingClientRect();
        const buttonVisible = window.innerHeight - rect.bottom >= 0;

        if (buttonVisible) {
            if (!fullWidthBar.classList.contains('visible')) {
                fullWidthBar.classList.add('visible');
                fullWidthBar.style.display = 'flex';
                fullWidthBar.style.opacity = '0';
                fullWidthBar.style.transform = 'translateY(20px)';
                setTimeout(() => {
                    fullWidthBar.style.opacity = '1';
                    fullWidthBar.style.transform = 'translateY(0)';
                }, 0);
            }
        } else {
            if (fullWidthBar.classList.contains('visible')) {
                fullWidthBar.style.opacity = '0';
                fullWidthBar.style.transform = 'translateY(20px)';
                setTimeout(() => {
                    fullWidthBar.style.display = 'none';
                    fullWidthBar.classList.remove('visible');
                }, 300); // Match the duration of your transition
            }
        }
    }
};
